export const endpoints = {
    SUBSIDIARY_ADMIN_VIEW: "subsidiary/admin/view",
    SUBSIDIARY_ADMIN_CREATE: "subsidiary/admin/create",
    SUBSIDIARY_ADMIN_UPDATE: "subsidiary/admin/update",
    SUBSIDIARY_ADMIN_DELETE: "subsidiary/admin/delete",
}